import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles((theme) => ({
  startIcon: {
    marginRight: 8,
    color: theme.palette.grey[600],
    fontSize: 20,
    "&[type=button]": {
      width: 20,
      height: 20,
      marginLeft: 12,
      padding: 0,
      background: "transparent",
      border: 0,
      outline: 0,
      "&:disabled": {
        opacity: 0.4,
        cursor: "default",
        pointerEvents: "none",
      },
      "& > svg": {
        fontSize: 20,
      },
      "&:hover > svg": {
        color: theme.palette.primary.main,
      },
      "&:focus > svg": {
        color: theme.palette.primary.main,
      },
      cursor: "pointer",
    },
  },
  endIcon: {
    marginLeft: 8,
    color: theme.palette.grey[600],
    fontSize: 20,
    "&[type=button]": {
      width: 20,
      height: 20,
      marginLeft: 12,
      padding: 0,
      background: "transparent",
      border: 0,
      outline: 0,
      "&:disabled": {
        opacity: 0.4,
        cursor: "default",
        pointerEvents: "none",
      },
      "& > svg": {
        fontSize: 20,
      },
      "&:hover > svg": {
        color: theme.palette.primary.main,
      },
      "&:focus > svg": {
        color: theme.palette.primary.main,
      },
      cursor: "pointer",
    },
  },
  infoButton: {
    width: 20,
    height: 20,
    marginLeft: 12,
    padding: 0,
    background: "transparent",
    border: 0,
    outline: 0,
    "&:hover > svg": {
      color: theme.palette.primary.main,
    },
    "&:focus > svg": {
      color: theme.palette.primary.main,
    },
    cursor: "pointer",
  },
  infoIcon: {
    color: theme.palette.grey[600],
    fontSize: 20,
  },
}));
